module.exports = __webpack_public_path__ + "static/media/4.1b36c0d2.png";